/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit IsAcknowledged/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import AcknowledgementText from './AcknowledgementText/index'
import React from 'react'
import TysiaCheckbox from 'DesignSystem/TysiaCheckbox/index'
import TysiaCheckboxInput from 'DesignSystem/TysiaCheckbox/TysiaCheckboxInput/index'



/** @type {import('Simple/types.js').View} */
export default function IsAcknowledged({
  children,
  viewPath = "/App/Account/Content/Settings/Content/PaymentProviders/Accounts/Content/ProviderAccount/AcknowledgePlatformFee/Content/IsAcknowledged",
  onChange
  
}) {
let selectedIsAcknowledgedValueData = fromData.useDataValue({ viewPath,
context: 'selected',
path: 'is_acknowledged',
})
let selectedIsAcknowledgedChangeData = fromData.useDataChange({ viewPath,
context: 'selected',
path: 'is_acknowledged',
})
let dtSpaceXxxs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xxxs'
        })
  return (<React.Fragment
>
<TysiaCheckbox
  viewPath={`${viewPath}/TysiaCheckbox`}
 data="selected.is_acknowledged"
 value={selectedIsAcknowledgedValueData}
 onChange={selectedIsAcknowledgedChangeData}
 size="small"
>
{childProps => (
<React.Fragment>
<TysiaCheckboxInput
{...childProps}
  viewPath={`${viewPath}/TysiaCheckboxInput`}
 alignSelf="flex-start"
 marginTop={dtSpaceXxxs}
/>
<AcknowledgementText
{...childProps}
  viewPath={`${viewPath}/AcknowledgementText`}
/>
</React.Fragment>
)}
</TysiaCheckbox>
{children}
</React.Fragment>)
}